import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Contents from './Contents'
import ImageResize from '@/utils/ImageResize'

export default {
  name: 'NoticeConfirm',
  components: {
    Loading,
    Contents
  },
  data () {
    return {
      valid: false,
      processing: false
    }
  },
  mounted () {
    console.log('values', this.values);
    this.valid = this.values.inpService &&
      this.values.inpDeliveryType &&
      this.values.inpNoticeType;

    // ページのリロードなど、前ページの選択情報が保持されていない場合は
    if (!this.valid) {
      this.$router.push({
        name: 'NoticeSelector',
        params: {
          noticeId: Constants.RegisterHash
        }
      });
      return;
    }
  },
  computed: {
    ...mapState({
      categoryName: state => state.notice.categoryName,

      // model
      serviceModel: state => state.noticeForm.serviceModel,
      deliveryTypeMstModel: state => state.noticeForm.deliveryTypeMstModel,
      serviceAttributeModel: state => state.noticeForm.serviceAttributeModel,
      noticeTypeMstModel: state => state.noticeForm.noticeTypeMstModel,
      serviceDetailModel: state => state.noticeForm.serviceDetailModel,

      // form
      values: state => state.noticeForm.values,

      // ロケーションのニックネーム
      locationNickname: state => state.noticeForm.locationNickname,
    }),
    ...mapGetters({
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      userServiceUuid: 'auth/userServiceUuid',
      isRegister: 'noticeForm/isRegister',
      isModify: 'noticeForm/isModify',
      getValue: 'noticeForm/getValue',
      deliveryType:'noticeForm/deliveryType'
    }),

    // list
    deliveryPatternList () {
      const array = $.extend(true, [], Constants.Notice.DeliveryPattern);
      return array.sort(Utility.sortByKey('index', true))
    },

    // result
    showResultCommunity () {
      // 配信先設定が「全配信:0」以外
      return this.values.inpTarget !== 0
    },
    resutCommunity () {
      console.log('serviceModel', this.serviceModel);
      return this.isAdmin
        ? this.serviceModel
          .find(item => item.serviceUuid === this.values.inpService).communityName
        : this.serviceDetailModel.communityName
      // try {
      //   return this.serviceModel
      //   .find(item => item.serviceUuid === this.values.inpService).communityName
      // } catch(e) {
      //   return ''
      // }
    },
    resultTarget () {
      const type = Utility.getConstantsLabel(['ContentsApply', 'DeliveryToKbn'], this.values.inpTarget)

      // 全配信
      if (this.values.inpTarget === 0) {
        return type
      // 属性配信
      } else if (this.values.inpTarget === 1) {
        let list = []
        this.serviceAttributeModel.filter(type => {
          type.attributeGroups
            .filter(item => this.values.inpAttribute.indexOf(item.attributeGroupUuid) !== -1)
            .forEach(item => {
              list.push(type.attributeTypeName + ' : ' + item.attributeGroupName)
            })
          return true
        })
        return type + '（' + (list.length ? list.join('、') : '') + '）'

      // 個別配信
      } else {
        return type + '（' + this.locationNickname + '）'
      }
    },
    resultDeliveryType () {
      return Utility.getObjectArrayValue(this.deliveryTypeMstModel, 'deliveryTypeMstUuid', this.values.inpDeliveryType, 'deliveryTypeName')
    },
    resultNoticeType() {
      const mst = this.noticeTypeMstModel.filter(
          item => item.noticeTypeMstUuid === this.values.inpNoticeType
      );
      if (!mst.length) return "";
      return mst[0].noticeType;
    },
    // result : 即時配信
    resultImmediateDeliveryEndDate () {
      return this.getValue('inpImmediateDeliveryEndDate') === Constants.BlankValue
        ? Constants.BlankValue
        : this.getValue('inpImmediateDeliveryEndDate') + ' ' + this.values.inpImmediateDeliveryEndHours + ':' + this.values.inpImmediateDeliveryEndMinutes
    },
    // result : 予約配信
    resultReservedDeliveryStartDate () {
      return this.getValue('inpReservedDeliveryStartDate') + ' ' + this.values.inpReservedDeliveryStartHours + ':' + this.values.inpReservedDeliveryStartMinutes
    },
    resultReservedDeliveryEndDate () {
      const date = this.getValue('inpReservedDeliveryEndDate')
      if (this.values.inpReservedDeliveryEndHours &&
        this.values.inpReservedDeliveryEndMinutes) {
        return date + ' ' + this.values.inpReservedDeliveryEndHours + ':' + this.values.inpReservedDeliveryEndMinutes
      } else {
        return date
      }
    },
    // result : 繰り返し配信
    resultDeliveryPattern () {
      if (this.values.inpDeliveryPattern.length === this.deliveryPatternList.length)
        return '毎日'
      return this.deliveryPatternList
        .filter(item => this.values.inpDeliveryPattern.indexOf(item.value) !== -1)
        .map(item => item.label).join('、')
    },
    resultRepeatedDeliveryStartDate () {
      return this.getValue('inpRepeatedDeliveryStartDate') + ' ' + this.values.inpRepeatedDeliveryStartHours + ':' + this.values.inpRepeatedDeliveryStartMinutes
    },
    resultRepeatedDeliveryEndDate () {
      return this.getValue('inpRepeatedDeliveryEndDate')
    },

    deliveryPattern() {
      return this.values.inpDeliveryPattern
        .reduce((sum, element) => sum + element)
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showToast: 'toast/show',
      showNoticeTestDeliveryModal: 'noticeTestDeliveryModal/show'
    }),
    
    turnBack () {
      this.$router.go(-1)
    },

    postData () {
      this.processing = true

      //jsonbの整形 : アンケートの場合
      let jsonb = {};
      if (this.values.inpDeliveryContents.question) {
        const obj = Object.keys(this.values.inpDeliveryContents)
          .filter(key => key.indexOf('answerOptions') !== -1)
          .map((key, index) => {
            return {
              optionNo: index + 1,
              answer: this.values.inpDeliveryContents[key],
            }
          })
          .filter(item => item.answer !== null)
        jsonb = {
          question: this.values.inpDeliveryContents.question,
          answerOptions: obj
        }
        if (this.values.inpDeliveryContents.soundFile) {
          jsonb.soundFile = $.extend(true, {}, this.values.inpDeliveryContents.soundFile)
        }
      //jsonbの整形 : そのほか
      } else {
        jsonb = $.extend(true, {}, this.values.inpDeliveryContents)
      }

      let parameters = {
        request: {
          serviceUuid: this.values.inpService,
          deliveryTypeMstUuid: this.values.inpDeliveryType,
          noticeTypeMstUuid: this.values.inpNoticeType,
          deliveryToKbn: this.values.inpTarget,
          deliveryContents: jsonb,
          // deliveryContents: this.values.inpDeliveryContents,
          noticeSenderName: this.values.inpAuthor,
          deliveryPlanKbn: this.values.inpDeliveryPlanType,
        }
      }

      // 配信先区分 : 属性配信
      if (this.values.inpTarget === 1) {
        parameters.request.deliveryToAttributeGroupUuids = this.values.inpAttribute
      }
      // 配信先区分 : 個別配信
      if (this.values.inpTarget === 2) {
        parameters.request.deliveryToDeviceSerial = this.values.inpDeviceSerial
        // parameters.request.deliveryToDeviceSerial = this.values.inpDeliveryPlanType
      }

      // 配信種別 : 即時配信
      if (this.values.inpDeliveryPlanType === 1) {
        if (this.values.inpImmediateDeliveryEndDate &&
          this.values.inpImmediateDeliveryEndHours &&
          this.values.inpImmediateDeliveryEndMinutes) {
          parameters.request.immediateDelivery = {
            deliveryEndDt: this.getValue('inpImmediateDeliveryEndDate').split('/').join('-') + ' ' + this.values.inpImmediateDeliveryEndHours + ':' + this.values.inpImmediateDeliveryEndMinutes
          }
        }
        // } else if (this.values.inpImmediateDeliveryEndDate) {
        //   parameters.request.immediateDelivery = {
        //     deliveryEndDt: this.getValue('inpImmediateDeliveryEndDate').split('/').join('-') + ' 23:59'
        //   }
        // }
      }
      // 配信種別 : 予約配信
      if (this.values.inpDeliveryPlanType === 2) {
        parameters.request.reservedDelivery = {
          deliveryStartDt: this.getValue('inpReservedDeliveryStartDate').split('/').join('-') + ' ' + this.values.inpReservedDeliveryStartHours + ':' + this.values.inpReservedDeliveryStartMinutes
        }
        if (this.values.inpReservedDeliveryEndDate &&
          this.values.inpReservedDeliveryEndHours &&
          this.values.inpReservedDeliveryEndMinutes) {
          parameters.request.reservedDelivery.deliveryEndDt = this.getValue('inpReservedDeliveryEndDate').split('/').join('-') + ' ' + this.values.inpReservedDeliveryEndHours + ':' + this.values.inpReservedDeliveryEndMinutes
        }
      }
      // 配信種別 : 繰り返し配信
      if (this.values.inpDeliveryPlanType === 3) {
        parameters.request.repeatedDelivery = {
          deliveryPattern: this.deliveryPattern,
          // deliveryPattern: Utility.intByBitArray(this.values.inpDeliveryPattern),
          deliveryStartDt:this.getValue('inpRepeatedDeliveryStartDate').split('/').join('-') + ' ' + this.values.inpRepeatedDeliveryStartHours + ':' + this.values.inpRepeatedDeliveryStartMinutes,
          deliveryEndDt: this.getValue('inpRepeatedDeliveryEndDate').split('/').join('-') + ' 23:59'
        }
      }

      // attachment/soundFileをS3にアップロード
      const attachments = this.values.inpDeliveryContents &&
        this.values.inpDeliveryContents.attachments
        ? this.values.inpDeliveryContents.attachments
        : []
      const soundFile = this.values.inpDeliveryContents &&
        this.values.inpDeliveryContents.soundFile
        ? [this.values.inpDeliveryContents.soundFile]
        : []
      this.postFiles(attachments)
        .then(res => {
          console.log('upload attachments: ', res)
          if (res === 'none') {
              return this.postFiles(soundFile)

          } else {
            let status = Utility.parseResponse(res)

            if (status.result) {
              let list = []
              res.forEach(item => list.push({
                fileName: item.data.fileName,
                contentType: item.data.contentType,
                fileUri: item.data.fileUri,
                fileSize: item.data.fileSize,
                thumbnailUri: item.data.thumbnailUri,
              }))
              parameters.request.deliveryContents.attachments = list

              return this.postFiles(soundFile)
            } else if (status.error) {
              // エラーメッセージ表示
              this.showError(res)
            } else {
              // アプリケーションエラー表示
              this.showError(null)
            }
          }
        })
        .then(res => {
          console.log('upload sound: ', res)
          if (res !== 'none' && res) {
            parameters.request.deliveryContents.soundFile = {
              fileName: res[0].data.fileName,
              contentType: res[0].data.contentType,
              fileUri: res[0].data.fileUri,
              fileSize: res[0].data.fileSize,
              thumbnailUri: res[0].data.thumbnailUri,
            }
          }

          console.log('register data', parameters.request)

          const methods =
            this.resultNoticeType === 'rapid_info'
              ? ['v1NoticeEmergencyAlert']
              : this.deliveryType === 'rapid_notice'
                ? ['v1NoticeRapidNotice']
                : ['v1NoticePost']

          return ApiManager.request(['notice'], methods, [parameters])
          })
          .then(res => {
            this.processing = false
            let status = Utility.parseResponse(res)

            if (status.result) {
              this.showToast({
                title: 'お知らせの登録',
                body: 'お知らせを登録しました。'
              })

              this.$router.push({
                name: 'Notice'
              })

            } else if (status.error) {
              // エラーメッセージ表示
              this.showError(res)
            } else {
              // アプリケーションエラー表示
              this.showError(null)
            }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(error)
        })
    },

    postFiles(fileList) {
      return new Promise((resolve, reject) => {
        (async () => {
          if (fileList === undefined || !fileList.length) resolve('none')

          const types = fileList.map(item => 'file')
          const methods = fileList.map(item => 'v1FileS3Post')
          const parameters = []
          for (const file of fileList) {
            const compressedImage = await ImageResize.getCompressedImage(file)
            parameters.push({
              attachment: compressedImage
            })
          }

          let resultList = []
          for (let i = 0; i < fileList.length; i++) {
            await ApiManager.request(
              [types[i]],
              [methods[i]],
              [parameters[i]])
              .then(res => {
                let status = Utility.parseResponse(res)
                if (status.result) {
                  resultList.push(res[0])
                } else if (status.error) {
                  reject(res)
                } else {
                  reject(null)
                }

              })
              // eslint-disable-next-line
              .catch(error => {
                reject(null)
              })
          }
          resolve(resultList)
        })()
      })
    },

    showNoticeTestDelivery() {
      this.showNoticeTestDeliveryModal()
    }
  }
}
